const ReviewBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="#333" />
    <rect x="2" y="2" width="20" height="20" fill="#ffd400" />
    <polygon
      points="8.5 15.15 10.04 16 9.75 14.19 11 12.91 9.27 12.65 8.5 11 7.73 12.65 6 12.91 7.25 14.19 6.96 16 8.5 15.15"
      fill="#333"
    />
    <polygon
      points="15.5 15.15 17.05 16 16.75 14.19 18 12.91 16.27 12.65 15.5 11 14.73 12.65 13 12.91 14.25 14.19 13.96 16 15.5 15.15"
      fill="#333"
    />
    <polygon
      points="12 10.15 13.54 11 13.25 9.19 14.5 7.91 12.77 7.65 12 6 11.23 7.65 9.5 7.91 10.75 9.19 10.46 11 12 10.15"
      fill="#333"
    />
  </svg>
);

export default ReviewBlockIcon;
